// What the analytical dataset results grid asks for on first load. The grid and
// the prefetch both derive their first request from these, so a prefetched page
// lands in exactly the cache entry the grid reads.

export const RESULTS_INITIAL_PAGE_SIZE = 500;

// Default sort mirrors the server's fallback ordering (patient_id ascending);
// patient_id tiebreaks non-unique sorts so pagination stays deterministic.
export const RESULTS_DEFAULT_SORT_MODEL = [{ field: 'patient_id', sort: 'asc' as const }];

/**
 * The grid's first-page query string (`page=1&pageSize=500&sort=patient_id:asc`),
 * in the same parameter order the shared DataGrid serializes its state.
 */
export const buildInitialResultsSearchParams = (): string => {
  const params = new URLSearchParams();
  params.set('page', '1');
  params.set('pageSize', String(RESULTS_INITIAL_PAGE_SIZE));
  params.set(
    'sort',
    RESULTS_DEFAULT_SORT_MODEL.map(({ field, sort }) => `${field}:${sort}`).join(',')
  );
  return params.toString();
};

// Patient ID stays in view while the variable columns scroll under it, at a fixed
// width so it does not flex (and so shift) with the other columns.
export const RESULTS_PINNED_FIELD = 'patient_id';
export const RESULTS_PINNED_COLUMN_WIDTH_PX = 160;
export const RESULTS_PINNED_COLUMNS = { left: [RESULTS_PINNED_FIELD] };
